import React, { useState, useEffect, useContext, useRef } from 'react';
import './MonitoredIndividualSummaryBar.css';
import baseApi from '../../common/api/base';
import LargeNumberIcon from '../LargeNumberIcon/LargeNumberIcon';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';
import MonitoredIndividualImage from '../MonitoredIndividualImage/MonitoredIndividualImage';

export default function MonitoredIndividualSummaryBar({ close }) {
  const environmentContext = useContext(EnvironmentContext);
  const [data, setData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [dataError, setDataError] = useState(false);
  const { hasToken, selectedMonitoredIndividual } = environmentContext;

  if (logComponent('MonitoredIndividualSummaryBar')) { console.debug('MonitoredIndividualSummaryBar rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('MonitoredIndividualSummaryBar')) { console.debug('MonitoredIndividualSummaryBar onMount'); }
    if (!hasToken) return;

  }, []);


  useEffect(() => {
    if (logComponent('MonitoredIndividualSummaryBar')) { console.debug('MonitoredIndividualSummaryBar useEffect [environmentContext.hasToken]'); }
    if (!hasToken) return;

    loadData();
  }, [environmentContext.hasToken]);

  const loadData = () => {
    if (logComponent('MonitoredIndividualSummaryBar')) { console.debug('MonitoredIndividualSummaryBar loadData'); }
    if (!hasToken) return;

    setData(null);
    setDataLoading(true);
    setDataError(false);

    baseApi.MonitoredIndividual.GetSummaryForPastDays(selectedMonitoredIndividual.monitoredIndividualId, 7)
      .then(
        result => {
          let prevData = (data ? data : {});

          setData(Object.assign(prevData, result.data));
          setDataLoading(false);
          setDataError(false);
        },
        error => {
          setDataLoading(false);
          setDataError(true);
        }
      )
  }

  const getNotesCount = () => {
    if (logComponent('MonitoredIndividualSummaryBar')) { console.debug('MonitoredIndividualSummaryBar getNotesCount'); }

    if (!data || !data.recentNotes) return 0;

    return data.recentNotes.reduce((prev, curr) => {
      return prev + curr.notes.length;
    }, 0);
  }

  return (
    <div className="Monitored-Individual-Summary-Bar">
      <div className="Monitored-Individual-Summary-Bar__monitoredindividual-info">
        <div className="Monitored-Individual-Summary-Bar__monitoredindividual-image">
          <MonitoredIndividualImage monitoredIndividual={selectedMonitoredIndividual} />
        </div>
        <div className="Monitored-Individual-Summary-Bar__monitoredindividual-text">
          <p className="Monitored-Individual-Summary-Bar__monitoredindividual-name">{`${selectedMonitoredIndividual.legalFirstName} ${selectedMonitoredIndividual.lastName}`}</p>
          <p className="Monitored-Individual-Summary-Bar__monitoredindividual-units">
            {
              selectedMonitoredIndividual.monitoredIndividualUnits.map((individualUnit, index) =>
                <span key={index}>{(index > 0 ? ', ' : '') + individualUnit.unit.name}</span>
              )
            }
          </p>
        </div>
      </div>
      {
        data &&
        <div className="Monitored-Individual-Summary-Bar__past-week">
          <p className="Monitored-Individual-Summary-Bar__past-week-heading">This past week</p>
          <div className="Monitored-Individual-Summary-Bar__past-week-content">
            <LargeNumberIcon number={data.checkInCount} text="Check-ins" />
            <LargeNumberIcon number={data.noteCount} text="Notes" />
            <LargeNumberIcon number={data.alarmsCount} text="Alarms" />
            <LargeNumberIcon number={data.activitiesCount} text="Activities" />
          </div>
        </div>
      }
    </div>
  );
}